<template>
    <div class="overflow-auto">
        <table class="excel">
            <thead>
                <tr>
                    <th />
                    <th v-for="(col, idx) in az.slice(0, 15)" :key="col">{{ col }}</th>



                </tr>
            </thead>
            <tbody>
                <tr class="row1">
                    <th>1</th>
                    <td class="requerido">placa_patente_única</td>
                    <td class="requerido">año_permiso_provisorio</td>
                    <td class="requerido">semestre_del_permiso</td>
                    <td class="requerido">persona_jurídica</td>
                    <td class="requerido">nombre_fantasia</td>
                    <td class="requerido">rol_unico_tributario</td>
                    <td class="requerido">dirección_automotora</td>
                    <td class="requerido">comuna_automotora</td>
                    <td class="requerido">rut_representate_legal</td>
                    <td class="requerido">nombre_representate_legal</td>
                    <td class="requerido">Marca</td>
                    <td class="requerido">modelo_vehículo</td>
                    <td class="requerido">año_fabricación_del_vehículo</td>
                    <td class="requerido">tipo_vehículo</td>
                    <td class="requerido">estado_permiso</td>
                </tr>
                <tr>
                    <th>2</th>
                    <td>PR0001</td>
                    <td>2025</td>
                    <td>1</td>
                    <td>AUTOMOTORA SPA</td>
                    <td>La Automotra</td>
                    <td>77777777-7</td>
                    <td>Las Violetas 5463</td>
                    <td>Temuco</td>
                    <td>22222222-2</td>
                    <td>Señor Representante</td>
                    <td>Suzuki</td>
                    <td>Vitara</td>
                    <td>2024</td>
                    <td>SUV</td>
                    <td>Vigente</td>
                </tr>

            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {

    },
    data: () => ({
        az: [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z',
            'AA',
            'AB',
            'AC',
            'AD',
            'AE',
            'AF',
            'AG',
            'AH',
            'AI',
            'AJ',
            'AK',
            'AL',
            'AM',
            'AN',
            'AO',
            'AP',
            'AQ',
            'AR',
            'AS',
            'AT',
            'AU',
            'AV',
            'AW',
            'AX',
            'AY',
            'AZ',
            'BA',
            'BB',
            'BC',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BK',
            'BL',
            'BM',
            'BN',
            'BO',
            'BP',
            'BQ',
            'BR',
            'BS',
            'BT',
            'BU',
            'BV',
            'BW',
            'BX',
            'BY',
            'BZ',
        ],
    }),
    computed: {},
    methods: {},
}
</script>

<style scoped>
/** Tablas que simulan Excel */

table.excel {
    background-color: #fff;
    border: 1px solid #9e9e9e;
    border-radius: 2px;
    border-spacing: 0;
    border-collapse: separate;
    font-family: sans-serif;
    font-size: 11px;
}

table.excel th,
table.excel td {
    border-top: 1px solid #f8f8f8;
    border-left: 1px solid #f8f8f8;
    border-right: 1px solid #cfcfcf;
    border-bottom: 1px solid #cfcfcf;
    padding: 3px 4px 0 4px;
    white-space: nowrap;
}

table.excel tbody th,
table.excel thead th {
    background-color: #eceff1;
    color: #000;
    font-weight: normal;
    text-align: center;
}

table.excel tr.row1 td.requerido {
    background-color: #04a398;
    border-top: 1px solid #05ab9f;
    border-left: 1px solid #05ab9f;
    border-right: 1px solid #03968c;
    border-bottom: 1px solid #03968c;
}

table.excel tbody tr.row1 td {
    color: white;
    font-weight: bold;
    background-color: #455a64;
    border-top: 1px solid #4d636e;
    border-left: 1px solid #4d636e;
    border-right: 1px solid #374951;
    border-bottom: 1px solid #374951;
}

table.excel tbody th {
    width: 18px;
}
</style>
